import { ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { IPreferredSupplier } from '../../interfaces/preferred-supplier';
import { PreferredSupplierService } from '../../services';

@Component({
  selector: 'preferred-supplier-details',
  templateUrl: './preferred-supplier-details.component.html',
  styleUrls: ['./preferred-supplier-details.component.scss'],
})
export class PreferredSupplierDetailsComponent implements OnInit {
  public id: number;
  public status: string;
  public preferredSupplier: IPreferredSupplier;
  public isLoading: boolean = true;
  public msgs: any[];

  constructor(
    private preferredSupplierService: PreferredSupplierService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      this.status = params['status'];
    });

    this.preferredSupplierService.get(this.id + ':' + this.status).then((result) => {
      this.preferredSupplier = result;
      this.isLoading = false;
    });
  }
}
